import React, { useState } from 'react'
import { View, Image } from 'react-native'
import { Portal } from 'react-native-paper'
import { REACT_NATIVE_S3 } from '../constants'

const baseURL = REACT_NATIVE_S3 + '/images/swatches/'

type ComponentProps = {
  sku?: string,
  /** The name of the image group */
  name: string,
  /** The primary color of the app. */
  accentColor: string,
  /** The selected color swatch. */
  selected: number,
  /** An object describing the color swatches. */
  swatches: SwatchType,
  /** On swatchchange handler. */
  onImageSwatchChange: Function,
  partner: string,
  /** Drilled to determine if on mobile */
  onMobile: boolean
  /** Prop that determines if component is hovered */
}

interface Style {
  zIndex: number,
  padding: number,
  position: string,
  width: number,
  height: number,
  top: number,
  left: number
  alignSelf: string,
  borderRadius: number,
  border: string,
  boxShadow: string,
}

export const withHover = (Component: any) => (({ ...props }) => {
  const [toggleHovered, setToggleHovered] = useState(false)
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement>(null)
  const [style, setStyle] = useState<Style>({ zIndex: -1, padding: 10, alignSelf: 'center', position: 'absolute', border: 'solid black', boxShadow: '0px 0px 0px rgb(0 0 0 / 16%), 3px 3px 3px rgb(0 0 0 / 23%)',  borderRadius: 168, width: 168, height: 168, top: 10, left: 0 })
  const onMouseOver = (e: any) => {
    setToggleHovered(() => true)
    const anchorPos = anchorEl.getBoundingClientRect()
    const leftOffset = anchorPos.left - ((style.width - anchorPos.width) / 2)
    setStyle((prevState) => {
      return { zIndex: prevState.zIndex, padding: prevState.padding, alignSelf: prevState.alignSelf, position: prevState.position, border: prevState.border, boxShadow: prevState.boxShadow, borderRadius: prevState.borderRadius, width: prevState.width, height: prevState.height, top: anchorPos.top - prevState.height - prevState.padding, left: leftOffset,   }
    })
  }

  const onMouseLeave = (e: any) => {
    setToggleHovered(() => false)
  }

  return (
    <View onMouseLeave={onMouseLeave} >
      <View onMouseEnter={onMouseOver} ref={setAnchorEl}>
        <Component {...props} anchorEl={anchorEl} />
      </View>
      {
        toggleHovered &&
        <Portal>
            <Image
              style={style}
              width={168}
              height={168}
              source={{ uri: baseURL + props.option + '.jpg' }}
            />
        </Portal>
      }
    </View>
  )
})
